import { useContext, useEffect, useState } from "react";
import { Box, Typography, Stack } from "@mui/material"
import { FeatureState } from "../../global/GlobalFcn";
import { ComputePercentage, GetPercentageFormat } from "../../global/Format";
import { UserSummary } from "../userSummary/UserSummary";
import { AwarenessChart } from "./AwarenessChart";
import { AwarePercentageLoader } from "../../loader/Loader";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { GetToolAwarePercentage } from "../../../global/API";
import { VM } from "../../../../../core/VM";

export const AwarePercentage = ({__SESSION, graphDatasets}) => {

    const { usage_state } = useContext(ToolContext)
    const { toolUsageData } = usage_state

    const view = VM()

    const [awarePercent, setAwarePercent] = useState({
        loader:false,
        no_pages_visited:0,
        no_total_pages:100
    })

    // SAMPLE DATA RESULT
    // const res_data_count = [
    //     {feature_id:1, feature_name:"dashboard", path:"1", count:10},
    //     {feature_id:2, feature_name:"bcloud", path:"2", count:1},
    //     {feature_id:3, feature_name:"policies", path:"3", count:2},
    //     {feature_id:4, feature_name:"general-maintenance", path:"4", count:3},
    //     {feature_id:5, feature_name:"hero", path:"5", count:4},
    //     {feature_id:6, feature_name:"tool-categories", path:"6", count:5},
    //     {feature_id:7, feature_name:"profile", path:"7", count:6},
    // ]
    // const res_target = [
    //     {feature_id:1, feature_name:"dashboard", path:"1", value:1},
    //     {feature_id:2, feature_name:"bcloud", path:"2", value:20},
    //     {feature_id:3, feature_name:"policies", path:"3", value:30},
    //     {feature_id:4, feature_name:"general-maintenance", path:"4", value:40},
    //     {feature_id:5, feature_name:"hero", path:"5", value:50},
    //     {feature_id:6, feature_name:"tool-categories", path:"6", value:60},
    //     {feature_id:7, feature_name:"profile", path:"7", value:70},
    // ]

    
    // NO NEED DATES GENERATES
    const getAwarePercentage = async() => {
        const res_target = toolUsageData.data.feature_data
       
        if (res_target) {
            setAwarePercent((prev) => ({...prev, 
                loader:true
            }))

            if (graphDatasets.data.dates.length > 0) {
                let role_type = graphDatasets.data.assigned_id === 0 ? __SESSION.data.uaccess[0]?.role_name : graphDatasets.data.role_name
                let ftrdata = await FeatureState('all', role_type) || console.log('Feature Name is Not Found!')
                if (ftrdata) {
                    let res_ftlr_data = ftrdata?.map(v => {return {feature_id:v.id, feature_name:v.feature_name, path:v.path } })
        
                    const combineArray = res_ftlr_data?.map((rfd) => {
                        const rt = res_target.find((rt) => rfd.feature_id === rt.feature_id && rfd.feature_name === rt.feature_name); 
                        return {...rfd, value:rt?.tool_pages || 0};
                    });
    
                    let qsp = {
                        company_id:__SESSION.data.uaccess[0]?.company_id,
                        tool_id:parseInt(process.env.REACT_APP_TID_BIZ),
                        user_id:graphDatasets.data.assigned_id === 0 ? parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]) : graphDatasets.data.assigned_id,
                    }
                    
                    let res_data = await GetToolAwarePercentage(qsp)
                    
                    const finalArray = combineArray?.map((ca) => {
                        const rdc = res_data?.find((rdc) => ca.feature_id === rdc.feature_id && ca.feature_name === rdc.feature_name); 
                        return {...ca, usage:rdc? ComputePercentage(rdc.count, ca.value) : 0};
                    });
        
                    const averageUsage = finalArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / finalArray?.length
                    
                    setAwarePercent((prev) => ({...prev, 
                        no_pages_visited:GetPercentageFormat(averageUsage),
                        loader:false
                    }))
                }
            }
        }
    }

    useEffect(() => {
        getAwarePercentage()
        // eslint-disable-next-line
    }, [toolUsageData.data.active_threshold, graphDatasets.data.dates])

    return (
        <Box sx={{bgcolor: "#fff", borderRadius: 4, p:4, border: 1, borderColor: "#cececeff", width: "100%"}}>
            <Stack sx={{gap: 2}}>
                <Stack minHeight="52px" gap={1.5}>
                    <Stack direction="row" gap={1.5}>
                        <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">Aware Percentage</Typography>
                        <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
                    </Stack>
                </Stack>
                <Box sx={{border: 0.5, color: "#E5E5EF"}}></Box>
                <UserSummary graphDatasets={graphDatasets} __SESSION={__SESSION} percentage={awarePercent.no_pages_visited} loader={awarePercent.loader}/>
                <Stack alignItems="center">
                    {awarePercent.loader ?
                        <AwarePercentageLoader view={{view}}/>
                    :
                        <AwarenessChart awarePercent={awarePercent}/>
                    }
                </Stack>
            </Stack>
        </Box>
    )
}